import React from 'react';

interface BannerProps {
  imageUrl: string;
  heading: string;
  description: string;
}

const Banner: React.FC<BannerProps> = ({ imageUrl, heading, description }) => {
  return (
    <div className="w-full md:w-1/2 px-4">
      <img src={imageUrl} alt="TrustKeys Network Meet Banner" className="bg-transparent" width={400} />
      <h2 className="text-2xl font-bold mt-4">{heading}</h2>
      <p className="text-gray-700 mt-2">{description}</p>
    </div>
  );
};

export default Banner;
